import {BaseModal} from "@/components/modal/BaseModal.tsx";
import {InviteMember} from "@/components/pages/InviteMember.tsx";

export default function InviteMemberModal() {
    return (
        <>
            <BaseModal title={"Add New Member"}
                       subtitle={"Add Member to your Workspace"}
                       size={"sm"}
            >
                <InviteMember/>
            </BaseModal>
        </>
    );
}

